import React from 'react';
import MroLabLanePage from './MroLabLanePage';

export default function MroLabEngineerPage() {
  return <MroLabLanePage laneKey="engineer" />;
}
